Vue.component('dashboard-targets', {
    mounted () {
        $('.carousel').find('.carousel-item').removeClass('active');
        $('.carousel').find('.carousel-inner').children().first().addClass('active');
    }
});